import filterTemplate from './filterBar.html';
import searchAddToSavedModal from './searchAddToSavedModal.html';
import searchSavedList from './searchSavedList.html';

const filterBar = {
    bindings: {
        placeholder: '@',
        search: '=',
        searchText: '=',
        disableField: '=',
        page: '@',
        onSave: '=',
        getSavedList: '=',
        onSaveApply: '=',
        onSaveDelete: '=',
    },
    template: filterTemplate,
    controller: function (
        $ionicScrollDelegate,
        $scope,
        $ionicModal,
        $ionicPopover
    ) {
        this.saveSearchName = '';
        this.list = [];

        this.addToFavorite = $ionicModal.fromTemplate(searchAddToSavedModal, {
            scope: $scope,
        });

        this.$ionicScrollDelegate = $ionicScrollDelegate;

        this.performSearch = () => {
            if (!this.page) this.$ionicScrollDelegate.scrollTop();
            this.search(this.searchText);
        };

        this.showModal = () => {
            this.saveSearchName = '';
            this.addToFavorite.show();
        };

        this.showSaved = ($event) => {
            if (!this.getSavedList) {
                return;
            }

            this.getSavedList().then((data) => {
                if (data) {
                    this.list = data;
                }
            });

            this.popover = $ionicPopover.fromTemplate(searchSavedList, {
                scope: $scope,
            });

            this.popover.show($event);
        };

        this.onChange = ($event) => {
            this.popover.hide();
        };

        this.hide = () => {
            this.addToFavorite.hide();
        };

        this.save = () => {
            this.onSave(this.saveSearchName);
            this.hide();
        };

        this.apply = (item) => {
            this.onSaveApply({ ...item.filter });
            this.popover.hide();
        };

        this.remove = ($event, item) => {
            $event.stopPropagation();

            this.onSaveDelete(item.filterName);
            this.list = this.list.filter((searchItem) => {
                return searchItem.filterName !== item.filterName;
            });
        };
    },
};

export default filterBar;



/** WEBPACK FOOTER **
 ** ./src/app/directives/filterBar/filterBar.js
 **/